export enum TileDisplay {
  Trends,
  Table
}
